import { widges } from '../../Config/const';

const initState = {
  conexionError: false,
  plantasVisibles: false,
  plantaActual: null,
  user: null,
  //widgesVisibles: null,
  plantas: null,
  idioma: 'es',
  widgesVisibles: widges,
  breadCrumb: [],
  configuration: {
    users: [],
    currentUser: null,
    plantas: [],
    loading: true,
  },
};
const proyectReducer = (state = initState, action) => {
  switch (action.type) {
    case 'initGlobal':
      return { ...state, conexionError: false };
    case 'initGlobal1':
      return { ...state, conexionError: action.dataT };
    case 'setPlantaVisible':
      return { ...state, plantasVisibles: action.dataT };
    case 'setWidgesVisibles':
      return { ...state, widgesVisibles: action.dataT };
    case 'setPlantas':
      return { ...state, plantas: action.dataT };
    case 'setPlantaActual':
      return { ...state, plantaActual: action.dataT };
    case 'setBreadCrumb':
      return { ...state, breadCrumb: action.dataT };
    case 'setIdioma':
      return { ...state, idioma: action.dataT };
    case 'setUserDataFromLocalStorage':
      return { ...state, user: action.dataT };
    case 'setConfigurationUsers':
      return {
        ...state,
        configuration: { ...state.configuration, users: action.dataT },
      };
    case 'updateConfigurationUser':
      return {
        ...state,
        configuration: { ...state.configuration, ...action.dataT },
      };
    case 'setConfigurationUser':
      return {
        ...state,
        configuration: {
          ...state.configuration,
          users: [...state.configuration.users, action.dataT],
        },
      };
    case 'setConfigurationPlantas':
      return {
        ...state,
        configuration: {
          ...state.configuration,
          plantas: action.dataT,
        },
      };
    case 'loadingConfiguration':
      return {
        ...state,
        configuration: {
          ...state.configuration,
          loading: action.dataT,
        },
      };
    case 'setCurrentUser':
      return {
        ...state,
        configuration: { ...state.configuration, currentUser: action.dataT },
      };
    case 'error':
      return { ...state, error: action.dataT, loading: false };
    default:
      return state;
  }
};
export default proyectReducer;
